import {useEffect, useRef, useState} from 'react';
import PlaceHolderImg from '@/assets/img/flexBuilderPlaceHolder.png';
import styles from './index.module.scss';

interface IProps {}

export const PlaceHolder = (props: IProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(200);

    useEffect(() => {
        const dom = containerRef.current;

        if (dom) {
            // 通过属性选择器和类名都能匹配
            const target = dom.closest('[data-card-target="card-center"].slate-card-center');

            if (target) {
                const width = target.getBoundingClientRect().width;
                setWidth(width);
            } else {
                console.log('没有找到符合条件的父元素');
            }
        }
    }, []);

    return (
        <div ref={containerRef} className={styles.container} style={{width}}>
            <img src={PlaceHolderImg} alt="" />
        </div>
    );
};
